import { render, staticRenderFns } from "./ReassignCreditsAndRemoveModal.vue?vue&type=template&id=fe227a76&"
import script from "./ReassignCreditsAndRemoveModal.vue?vue&type=script&lang=js&"
export * from "./ReassignCreditsAndRemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports